/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

export const onClientEntry = () => {
  // Log build number if available
  if (process.env.GATSBY_BUILD_NUMBER) {
    console.log(`🏗️ Build Number: ${process.env.GATSBY_BUILD_NUMBER}`);
  }
  
  console.log('🧹 Starting service worker and cache cleanup...');
  
  // Force unregister all service workers
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      if (registrations.length > 0) {
        console.log(`🔧 Found ${registrations.length} service worker(s) to unregister:`, registrations.map(reg => reg.scope));
        registrations.forEach((registration, index) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log(`✅ Service worker ${index + 1} unregistered successfully`);
            } else {
              console.log(`❌ Failed to unregister service worker ${index + 1}`);
            }
          });
        });
      } else {
        console.log('✨ No service workers found - nothing to unregister');
      }
    }).catch(error => {
      console.error('❌ Error getting service worker registrations:', error);
    });
  } else {
    console.log('⚠️ Service Workers not supported in this browser');
  }
  
  // Clear all caches - this is crucial for chunk loading issues
  if ('caches' in window) {
    caches.keys().then(function(names) {
      if (names.length > 0) {
        console.log(`🗑️ Found ${names.length} cache(s) to clear:`, names);
        const deletePromises = names.map(name => {
          return caches.delete(name).then(success => {
            if (success) {
              console.log(`✅ Cache "${name}" deleted successfully`);
            } else {
              console.log(`❌ Failed to delete cache "${name}"`);
            }
            return success;
          });
        });
        
        Promise.all(deletePromises).then(results => {
          const successCount = results.filter(Boolean).length;
          console.log(`🎉 Cache cleanup complete: ${successCount}/${names.length} caches cleared`);
        });
      } else {
        console.log('✨ No caches found - nothing to clear');
      }
    }).catch(error => {
      console.error('❌ Error accessing caches:', error);
    });
  } else {
    console.log('⚠️ Cache API not supported in this browser');
  }
  
  console.log('🚀 Cleanup script execution completed');
}

// const scrollTo = (id) => () => {
//   // console.log("scrollTo", id);
//   // const el = document.querySelector(id)
//   // if (el) return window.scrollTo(0, el.offsetTop - 60) // offset = clearance for header
//   // return false
// }

// export const onRouteUpdate = ({ location }) => {
//     // if (location.hash) {
//     //   window.setTimeout(scrollTo(location.hash), 1000)
//     // }
//
//     // // Party Town
//     // if (process.env.NODE_ENV !== 'production') {
//     //     return null;
//     // }
//     // const pagePath = location ? location.pathname + location.search + location.hash : undefined;
//     // setTimeout(() => {
//     //     if (typeof window.gtag === 'function') {
//     //         window.gtag('event', 'page_view', { page_path: pagePath });
//     //     }
//     // }, 100);
// };
